
if (document.readyState !== 'loading') {
    //console.log("ready!");
    ready();
} else {
    document.addEventListener('DOMContentLoaded', ready);
}

function ready() {
    var accordion = document.getElementsByTagName("dt");

    for (var i = 0; i<accordion.length; i++){
        accordion[i].addEventListener('click', function(){
            accordionClick(event);
        
        });
    }

    var waypoints = document.querySelectorAll('.SectionNumbers');
    for (var i = waypoints.length - 1; i >= 0; i--) {
    		var waypoint = new Waypoint({
    				element: waypoints[i],
    				handler: function(direction) {
    						numberCounter();
    				}
                    ,offset: '15%',
    		});
    }
    
}



function ButtonSubscribe(){
  // Get the checkbox
  var checkBox = document.getElementById("toggleswitch");
  var price = document.getElementById("ToggleSelectPrice");
  var time = document.getElementById("ToggleSelectPer");
  let monthVal = "$299";
  let yearVal = "$2,999";
  // If the checkbox is checked, display the output text
  if (checkBox.checked == true){
    price.innerHTML = yearVal;
    time.innerHTML = "/Jahr";
    document.getElementById("subs_monthly").style.display = "none";
    document.getElementById("subs_yearly").style.display = "block";
  } else {
    price.innerHTML = monthVal;
    time.innerHTML = "/Monat";
    document.getElementById("subs_yearly").style.display = "none";
    document.getElementById("subs_monthly").style.display = "block";
  }
}

var accordionClick = (eventHappened) => {
    //console.log(eventHappened);
    var targetClicked =event.target;
    //console.log(targetClicked);
    var classClicked = targetClicked.classList;
    //console.log("target clicked: " + targetClicked);
    //console.log(classClicked[0]);
    while ((classClicked[0] !="description-title")){
        //console.log("parent element: " + targetClicked.parentElement);
        targetClicked = targetClicked.parentElement;
        classClicked = targetClicked.classList;
        //console.log("target clicked while in loop:" + targetClicked);
        //console.log("class clicked while in loop: " + classClicked);
    }
    var description = targetClicked.nextElementSibling;
    //console.log(description);
    var expander = targetClicked.children[0];
    if (description.style.maxHeight){
        description.style.maxHeight = null;
        expander.innerHTML = "+"
        //&#10133;
    }
    else {
        var allDescriptions = document.getElementsByTagName("dd");
        for (var i = 0; i < allDescriptions.length; i++){
            //console.log("current description: " + allDescriptions[i]);
            if (allDescriptions[i].style.maxHeight){
                //console.log("there is a description already open");
                allDescriptions[i].style.maxHeight = null;
                allDescriptions[i].previousElementSibling.children[0].innerHTML = "+"
            }
        }
        description.style.maxHeight = description.scrollHeight + "px";
        expander.innerHTML = "-";
      //&#10134;
        
    }
}


function numberCounter(){
  const counters = document.querySelectorAll('.tableNumbers.hideElementForMobile.hideElementForTablet .topRow');
  const speed = 200;
  counters.forEach( counter => {
     
     const animate = () => {
        let value = +counter.getAttribute("data-count"); 
        const data = +counter.innerText;
       
        const time = value / speed;
        
       if(data < value) {
            counter.innerText = Math.ceil(data + time);
            setTimeout(animate, 1);
            
       }else{
            counter.innerText = counter.getAttribute("data-orig");
            
       }
       
     }
     animate();
     
  });

}

window.addEventListener('load', function(event) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
    let subs_plan = params.selling_plan; // "some_value"
    if(subs_plan){
      var recur_snippet = document.querySelectorAll('#recurpay-pdp-widget');
      if(recur_snippet.length){
        var subscribe_opt = document.querySelector('#recurpay__frequency_label'); console.log(subscribe_opt.options);
        for(var i = 0; i < subscribe_opt.options.length; i++){ 
          let opt_label = subscribe_opt.options[i].text;
          let selling_plan = subscribe_opt.options[i].attributes['data-selling-plan'].value;
          
          if(subs_plan == selling_plan){ 
            subscribe_opt.options[i].setAttribute('selected', 'selected'); 
            document.querySelector('#recurpay_plan_name').value = subscribe_opt.options[i].attributes['data-plan-name'].value;
            document.querySelector('#recurpay_plan_id').value = subscribe_opt.options[i].attributes['data-plan'].value;
            document.querySelector('#recurpay_selling_plan_id').value = subscribe_opt.options[i].attributes['data-selling-plan'].value;
            //subscribe_opt.dispatchEvent(new Event('change'));
            break;
          }
        }    
      }
    }

    var elementExists = document.querySelector("#collection_multibuy");
    if(elementExists){ 
      let active_btns = document.querySelectorAll(".productgrid--sidebar-button-active");
      let active_uls = document.querySelectorAll(".filter-group-active");
      let active_li = document.querySelectorAll(".collection-filters__filter-list-item.collection-filters__filter-list-item--active");
      [].forEach.call(active_btns, function(el) {
        el.classList.remove("productgrid--sidebar-button-active");
      });
      [].forEach.call(active_uls, function(el) {
        el.classList.remove("filter-group-active");
        el.dataset.accordionState = 'close';
      });
      //[].forEach.call(active_li, function(el) {
        //el.querySelectorAll("a.collection-filters__filter-link").setAttribute('data-filter-active', '');
      //});
      
      // let tableContainer = document.querySelector('#collection_multibuy .productgrid--wrapper');
      // const observer = new IntersectionObserver( 
      //   ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
      //   {threshold: [1]}
      // );
      // observer.observe(tableContainer);
    }
});


